'use client';

import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useGetLeagueStandingsQueryData } from '@/app/(default)/(leagues)/leagues/[slug]/session/[sessionId]/queries';
import ClubRating from '@/modules/league/details/standings/ClubRating';
import Custom from '@/modules/league/details/standings/Custom';
import Factors from '@/modules/league/details/standings/Factors';
import IfpRr from '@/modules/league/details/standings/IfpRr';
import StandingsTableSkeleton from '@/modules/league/details/standings/StandingsTableSkeleton';
import UpDown from '@/modules/league/details/standings/UpDown';
import { SessionLeagueDetails } from '@/modules/league/new-components/types';

interface StandingsProps {
  session: SessionLeagueDetails;
  params: { slug: string; sessionId: string };
}

export default function Standings({ session, params }: StandingsProps) {
  const { sessionId } = params;
  const rankType = session.RankingType;

  const {
    data: standings,
    isRefetching,
    isFetching,
  } = useGetLeagueStandingsQueryData(sessionId, rankType);

  return (
    <>
      {session?.RankingType === 'UpDown' &&
      standings &&
      standings?.players?.length > 0 &&
      !isRefetching ? (
        <UpDown session={session} players={standings.players} totals={standings.totals} />
      ) : session?.RankingType === 'Factors' && standings && standings?.players?.length > 0 ? (
        <Factors session={session} players={standings.players} />
      ) : (session?.RankingType === 'ClubRating' || session?.RankingType === 'DUPRRating') &&
        standings &&
        standings?.players?.length > 0 ? (
        <ClubRating session={session} players={standings.players} />
      ) : session?.RankingType === 'Custom' && standings && standings?.players?.length > 0 ? (
        <Custom session={session} players={standings.players} />
      ) : session?.RankingType === 'IFP_RR' && standings && standings?.players?.length > 0 ? (
        <IfpRr session={session} players={standings.players} />
      ) : isRefetching || isFetching ? (
        <StandingsTableSkeleton />
      ) : standings?.players?.length === 0 ? (
        <div className='w- my-2 w-full overflow-x-auto text-center font-semibold md:ml-4'>
          <FontAwesomeIcon className='mr-2 text-2xl' icon={faCircleExclamation} />
          <div>No Players at this time</div>
        </div>
      ) : null}
    </>
  );
}
